import React, { useState, useEffect } from 'react';

const Countdown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
    return timeLeft;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  const formatNumber = (num) => {
    return num < 10 ? `0${num}` : num;
  };

  return (
    <div className="dark-timer-section">
      <div className="dark-timer-overlay"></div>
      <div className="container" style={{position: 'relative', zIndex: 2}}>
        <div className="dark-timer-grid">
          <div className="dark-timer-item">
            <svg className="dark-timer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            <div className="dark-timer-content">
              <div className="dark-timer-num">{timeLeft.days !== undefined ? formatNumber(timeLeft.days) : '00'}</div>
              <div className="dark-timer-label">DAYS</div>
            </div>
          </div>
          <div className="dark-timer-item">
            <svg className="dark-timer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <div className="dark-timer-content">
              <div className="dark-timer-num">{timeLeft.hours !== undefined ? formatNumber(timeLeft.hours) : '00'}</div>
              <div className="dark-timer-label">HOURS</div>
            </div>
          </div>
          <div className="dark-timer-item">
            <svg className="dark-timer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <div className="dark-timer-content">
              <div className="dark-timer-num">{timeLeft.minutes !== undefined ? formatNumber(timeLeft.minutes) : '00'}</div>
              <div className="dark-timer-label">MINUTES</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
